import { useRouter, type NavigationGuardWithThis } from "vue-router";
import { appContainer } from "../container";
import { ActiveRolesStore } from "../stores/ActiveRolesStore";
import { Roles } from "../interface/UserInterface";
import { UserService } from "../services/userService";
import { useUserStore } from "../stores/UserStore";
import { useAdminCompaniesStore } from "../stores/AdminCompaniesStore";

export const HasInvitation: NavigationGuardWithThis<undefined> = async () => {
  const userService: UserService = appContainer.resolve(UserService);

  const userStore = useUserStore();
  const router = useRouter();
  const activeRolesStore = ActiveRolesStore();

  if (activeRolesStore.activeRoles.includes(Roles.SuperAdmin)) {
    return true;
  }

  const invitations = await userService
    .getInvitedUser({
      invited_user: userStore.user?.id,
      all: true,
      allUsers: true,
      invitation_sent: true,
    })
    .then((result) => result.items);

  // Reuse the already-fetched invitations to cache the admin's companies
  // (no extra API call). Used by the Users listing to scope to the admin.
  useAdminCompaniesStore().setFromInvitations(invitations);

  if (invitations.length) {
    return true;
  } else {
    router.push("/no-invitation");
  }
};
